/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetProjectsProjectidOptions, GetProjectsProjectidStatus200, GetProjectsProjectidStatus401, GetProjectsProjectidStatus404, GetProjectsProjectidStatus500 } from '../types/GetProjectsProjectid'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getProjectsProjectid } from '../clients/getProjectsProjectid'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getProjectsProjectidSuspenseQueryKey = ({ path }: Omit<GetProjectsProjectidOptions, 'headers'>) => [{ url: '/projects/:projectId', params: path }] as const

type GetProjectsProjectidSuspenseQueryKey = ReturnType<typeof getProjectsProjectidSuspenseQueryKey>

export function getProjectsProjectidSuspenseQueryOptions({ path }: GetProjectsProjectidOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getProjectsProjectidSuspenseQueryKey({ path })
  return queryOptions<GetProjectsProjectidStatus200, ResponseErrorConfig<GetProjectsProjectidStatus401 | GetProjectsProjectidStatus404 | GetProjectsProjectidStatus500>, GetProjectsProjectidStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getProjectsProjectid({ ...config, path, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /projects/:projectId}
 */
export function useGetProjectsProjectidSuspense<TData = GetProjectsProjectidStatus200, TQueryKey extends QueryKey = GetProjectsProjectidSuspenseQueryKey>({ path }: { path: GetProjectsProjectidOptions['path'] | (() => GetProjectsProjectidOptions['path']) }, options: {
  query?: Partial<UseSuspenseQueryOptions<GetProjectsProjectidStatus200, ResponseErrorConfig<GetProjectsProjectidStatus401 | GetProjectsProjectidStatus404 | GetProjectsProjectidStatus500>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getProjectsProjectidSuspenseQueryKey(resolvedParams)

  const queryResult = useSuspenseQuery({
   ...getProjectsProjectidSuspenseQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetProjectsProjectidStatus401 | GetProjectsProjectidStatus404 | GetProjectsProjectidStatus500>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
